import type { Translate } from 'next-translate';
import { type FC } from 'react';
import { Center, Text } from '@eqi-investimentos/react';
export const HasRecommendationTag: FC<HasRecommendationTagProps> = ({
  t
}) => {
  return <>
      <Center id="badge-recomendation-header" minW="8.875rem" h="1.75rem" p="xs" gap="0.625rem" bgColor="background.tertiary" borderRadius="0.125rem" transition="0.4s all ease-in-out" data-sentry-element="Center" data-sentry-source-file="HasRecommendationTag.tsx">
        <Text fontSize="md" fontWeight="normal" lineHeight="4" color="content.primary" whiteSpace="nowrap" overflow="hidden" transition="0.4s all ease-in-out" data-sentry-element="Text" data-sentry-source-file="HasRecommendationTag.tsx">
          {t('widgets.RecentContentWidget.hasRecommendation')}
        </Text>
      </Center>
    </>;
};
type HasRecommendationTagProps = {
  t: Translate;
};